/**
 * File System Access — carpeta BNT.TaxRepository en el navegador.
 */
import { TAX_REPO_ROOT_FOLDER } from "@/lib/exportTaxRepositoryPaths";

export {
  isPickerPermissionError,
  isPickerUserAbort,
  supportsDirectoryPicker,
  writeRelativeFile,
  fileHandleExists,
} from "@/lib/exportDirectorioFs";

async function getOrCreateDir(rootHandle, parts) {
  let current = rootHandle;
  for (const part of parts) {
    current = await current.getDirectoryHandle(part, { create: true });
  }
  return current;
}

/** Crea o devuelve BNT.TaxRepository bajo la carpeta raíz del usuario. */
export async function ensureTaxRepositoryRootDirectory(userRootHandle) {
  return userRootHandle.getDirectoryHandle(TAX_REPO_ROOT_FOLDER, { create: true });
}

export { getOrCreateDir };
